import React from 'react';

// Jyto brand logo. Renders the locator symbol, the wordmark, or the full
// lockup. Adapted from the Jyto Design System Logo component to this app's
// inline-style convention (literal hex, no CSS custom properties).
//
// variant: 'full' | 'symbol' | 'wordmark'
// tone:    'color' (dark grounds text) | 'white' (dark backgrounds) | 'mono'
// size:    wordmark cap height in px; the symbol scales with it.

export function LogoMark({ tone = 'color', size = 22, style }) {
  const ringOuter = tone === 'color' ? '#1E3FAE' : tone === 'white' ? '#FFFFFF' : 'currentColor';
  const ringInner = tone === 'color' ? '#3D5CDE' : tone === 'white' ? '#9DB0F2' : 'currentColor';
  const core      = tone === 'mono'  ? 'currentColor' : tone === 'white' ? '#1FC68A' : '#0E9F6E';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      style={{ display: 'block', flex: '0 0 auto', ...style }}
    >
      <circle cx="24" cy="24" r="18.5" stroke={ringOuter} strokeWidth="3" />
      <circle cx="24" cy="24" r="11"   stroke={ringInner} strokeWidth="3" />
      <circle cx="24" cy="24" r="4.5"  fill={core} />
    </svg>
  );
}

export function Logo({ variant = 'full', tone = 'color', size = 19, style, ...rest }) {
  const word = tone === 'color' ? '#0A1F4A' : tone === 'white' ? '#FFFFFF' : 'currentColor';
  const sym = Math.round(size * 1.32);
  return (
    <span
      role="img"
      aria-label="Jyto"
      style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.42), ...style }}
      {...rest}
    >
      {variant !== 'wordmark' && <LogoMark tone={tone} size={sym} />}
      {variant !== 'symbol' && (
        <span style={{
          fontFamily: "'Geist', system-ui, -apple-system, 'Segoe UI', sans-serif",
          fontWeight: 800,
          fontSize: size,
          letterSpacing: '-0.04em',
          lineHeight: 1,
          color: word,
        }}>Jyto</span>
      )}
    </span>
  );
}

export default Logo;
